import { render, staticRenderFns } from "./ActivityPictureEditor.vue?vue&type=template&id=3c8f566e&scoped=true"
import script from "./ActivityPictureEditor.vue?vue&type=script&lang=js"
export * from "./ActivityPictureEditor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c8f566e",
  null
  
)

export default component.exports